import React from "react"
import { Form } from "sharedTypes"
import { Stack } from "@chakra-ui/react"
import FormSection from "pages/EventShow/Forms/FormManagement/FormSection"
import DynamicInputFields from "../DynamicInputFields"

type Props = {
  form: Form;
  mergeTagEventTitle?: string
}

const RegistrationFields = ({ form, mergeTagEventTitle }: Props) => (
  <FormSection first>
    <Stack spacing={4}>
      <DynamicInputFields form={form} mergeTagEventTitle={mergeTagEventTitle} />
    </Stack>
  </FormSection>
)

export default RegistrationFields
